export const PAYMENT_TYPES = {
  POSTPAID: 'POSTPAID',
  PREPAID: 'PREPAID'
}
